import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Container, Title, Subtitle, Description } from './styles';
import { ButtonPrimary } from '../../shared/components';
import Header from '../../shared/components/PublicPageHeader';
import Footer from '../../shared/components/PublicPageFooter';

export default function InternalServerError() {
  const navigate = useNavigate();
  return (
    <>
      <Header color="#fff" />
      <Container>
        <Title>500</Title>
        <Subtitle>Erro interno do servidor</Subtitle>
        <Description>
          Por favor, tente novamente mais tarde. Fiquei a vontade para contactar
          o suporte caso o erro persista.
        </Description>
        <Description>
          Clique no botão abaixo para voltar a página inicial
        </Description>
        <ButtonPrimary.Normal
          label="Voltar para tela inicial"
          onClick={() => {
            navigate('/');
          }}
        />
      </Container>
      <Footer />
    </>
  );
}
